export const API_ROUTE = 'https://murmuring-cliffs-65490.herokuapp.com/api/v1'

export const localUsers = [
  {id: 1, name: 'Kenz Leng'},
  {id: 2, name: 'Eli Fuchsman'},
  {id: 3, name: 'Shawn Lee'},
  {id: 4, name: 'Alex Mora'},
  {id: 5, name: 'Evan Swanson'},
  {id: 6, name: 'Dana Truong'},
  {id: 7, name: 'Dmitrii Gubko'}
]

export const GITHUB_ROUTES = {
  REPO: 'https://github.com/DirtR2208',
  DANA: 'https://github.com/tramtram1130',
  EVAN: 'https://github.com/EvanSSwanson',
  DMITRII: 'https://github.com/dgubko',
  KENZ: 'https://github.com/kenzjoy',
  ELI: 'https://github.com/efuchsman',
  SHAWN: 'https://github.com/Shawnl93',
  ALEX: 'https://github.com/AlexMR-93'
}